$('document').ready(() => {
    const galleryThumb = new Swiper('.product-gallery__thumb', {
        speed: 400,
        spaceBetween: 16,
        slidesPerView: 4,
        direction: 'vertical',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                direction: 'horizontal',
            },
            1024: {
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 4,
                direction: 'vertical',
            }
        }
    });
    const galleryProduct = new Swiper('.product-gallery__slider', {
        slidesPerView: 1,
        pagination: {
            el: '.product-gallery__pagination',
        },
        thumbs: {
            swiper: galleryThumb
        }
    });

    const ModalGalleryThumb = new Swiper('.product-gallery-modal__thumb-slider', {
        speed: 400,
        spaceBetween: 14,
        slidesPerView: 'auto',
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            1024: {}
        }
    });

    const ModalGalleryProduct = new Swiper('.product-gallery-modal__main-slider', {
        slidesPerView: 1,
        spaceBetween: 100,
        navigation: {
            nextEl: '.product-gallery-modal__main-slider-nav--next',
            prevEl: '.product-gallery-modal__main-slider-nav--prev',
        },
        pagination: {
            el: '.product-gallery-modal__main-slider-pagination',
        },
        thumbs: {
            swiper: ModalGalleryThumb
        },
    });

    $('.product-gallery__slider-item-fig:not(._no-zoom)').mousemove((e) => {
        let zoomer = e.currentTarget;

        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches?.[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetY = e.touches?.[0].pageY
        x = offsetX / zoomer.offsetWidth * 100
        y = offsetY / zoomer.offsetHeight * 100
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
    })
    $('.product-gallery__slider-item').click((e) => {
        if (e.target.closest('._no-zoom')) return;

        $('.product-gallery-modal').addClass('product-gallery-modal--open');
        bodyFixPosition()
        let activeSlideNum = galleryProduct.activeIndex;
        ModalGalleryProduct.slideTo(activeSlideNum)
    });
    let closModalGallery = () => {
        $('.product-gallery-modal--open').removeClass('product-gallery-modal--open');
        bodyUnfixPosition()
    }
    $('.product-gallery-modal').click((e) => {
        if($(e.target).hasClass('product-gallery-modal--open') || $(e.target).hasClass('product-gallery-modal__close-img')) {
            let activeSlideNum = ModalGalleryProduct.activeIndex;
            galleryProduct.slideTo(activeSlideNum);
            closModalGallery();
        }
    })
    $(window).keyup((e) =>{
        if (e.code === 'Escape' && document.querySelector('.product-gallery-modal--open')) {
            $('.product-gallery-modal--open').removeClass('product-gallery-modal--open');
            closModalGallery();
        }
    })
})
